export const localCache = {
  data: {},
  remove: function (url) {
    delete localCache.data[url];
  },
  exist: function (url) {
    // eslint-disable-next-line no-prototype-builtins
    return localCache.data.hasOwnProperty(url) && localCache.data[url] !== null;
  },
  get: function (url) {
    // const keys = Object.keys(localCache.data);
    // console.log('cache size' + keys.length);
    return localCache.data[url];
  },
  set: function (url, cachedData) {
    const keys = Object.keys(localCache.data);
    const data = {}
    if(keys.length > 1){
      data[keys[0]] = localCache.data[keys[0]];
      localCache.data = data;
    }
    //localCache.remove(url);
    localCache.data[url] = cachedData;
  }
};
